import { useQuery } from '@tanstack/react-query';
import { Building2, Plus } from 'lucide-react';
import { api } from '../../lib/api';

export function FixedAssetListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['fixed-assets'],
    queryFn: () => api.get<{ data: any[] }>('/api/fixed-assets'),
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>固定資産台帳</h1>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium" style={{ backgroundColor: 'var(--accent-color)' }}>
          <Plus size={18} />新規登録
        </button>
      </div>
      <div className="card overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <div className="w-8 h-8 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" />
          </div>
        ) : data?.data.length === 0 ? (
          <div className="text-center py-12">
            <Building2 size={48} className="mx-auto mb-4" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-secondary)' }}>固定資産が登録されていません</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th style={{ color: 'var(--text-primary)' }}>資産コード</th>
                <th style={{ color: 'var(--text-primary)' }}>資産名</th>
                <th style={{ color: 'var(--text-primary)' }}>区分</th>
                <th style={{ color: 'var(--text-primary)' }}>取得日</th>
                <th className="text-right" style={{ color: 'var(--text-primary)' }}>取得価額</th>
                <th className="text-right" style={{ color: 'var(--text-primary)' }}>帳簿価額</th>
                <th style={{ color: 'var(--text-primary)' }}>ステータス</th>
              </tr>
            </thead>
            <tbody>
              {data?.data.map((asset: any) => (
                <tr key={asset.id}>
                  <td className="font-mono" style={{ color: 'var(--text-primary)' }}>{asset.assetCode}</td>
                  <td style={{ color: 'var(--text-primary)' }}>{asset.assetName}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{asset.assetCategory}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{asset.acquisitionDate}</td>
                  <td className="text-right font-mono" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(asset.acquisitionCost).toLocaleString()}</td>
                  <td className="text-right font-mono" style={{ color: 'var(--text-primary)' }}>¥{parseFloat(asset.bookValue || 0).toLocaleString()}</td>
                  <td><span className={`badge ${asset.status === 'active' ? 'badge-success' : 'badge-error'}`}>{asset.status === 'active' ? '使用中' : '除却済'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

